// Chip.tsx (CX2) - chips as real discs, denomination-coloured. Ported from the POC (verified 08c stack:
// research found nothing free that looked like a casino chip, so it is ~40 lines of SVG instead of a
// dependency). The disc sizes itself to its font-size box via width/height 1em, so the felt's proportional
// (cqw) sizing scales the chip with everything else - no fixed pixels here.
export interface ChipStackProps {
  /** the bet amount, in whole dollars - picks the denomination colour. */
  amount: number;
}

/** Casino-chip colour bands by amount: grey < $5, red < $25, green < $100, black/purple ≥ $100. */
export function ChipStack({ amount }: ChipStackProps) {
  const colors =
    amount >= 100
      ? ['#111', '#5b21b6']
      : amount >= 25
        ? ['#166534', '#22c55e']
        : amount >= 5
          ? ['#991b1b', '#ef4444']
          : ['#374151', '#9ca3af'];
  return (
    <svg viewBox="0 0 16 16" aria-hidden className="chip">
      <circle cx="8" cy="8" r="7.2" fill={colors[0]} stroke={colors[1]} strokeWidth="1.6" />
      <circle cx="8" cy="8" r="3.4" fill="none" stroke={colors[1]} strokeWidth="1.1" opacity="0.85" />
    </svg>
  );
}
